import React from "react";
import PropTypes from "prop-types";


export default function Cost(comment, setComment) {

    return (
      <div className="cost">
        Kommentar
          <div>
            <input type="text" value={comment} className="description" 
              onChange={(e) => {
                setComment(e.target.value);}}/>
          </div>
      </div>
    );
  }

  Comment.propTypes = {
    comment: PropTypes.string.isRequired,
    setComment: PropTypes.func.isRequired
  };